import { useCallback } from 'react';

import type { LocationItem } from 'src/app/pages/search/shared/types';

import { useSearchForCities } from './hooks/useSearchForCities';
import { useSearchForRelevantCities } from './hooks/useSearchForRelevantCities';

type Result = ModelHookResult<
	undefined,
	{
		searchForCities: (queryLocation: string, selectedLocation: string) => Promise<readonly LocationItem[]>;
	}
>;

export function useLocationSearchCities(): Result {
	const {
		actions: { searchForCities },
	} = useSearchForCities();
	const {
		actions: { searchForRelevantCities },
	} = useSearchForRelevantCities();

	return {
		actions: {
			searchForCities: useCallback(
				async (queryLocation: string, selectedLocation: string) => {
					if (queryLocation) {
						return searchForCities(queryLocation, selectedLocation);
					}
					return searchForRelevantCities(selectedLocation);
				},
				[searchForRelevantCities, searchForCities],
			),
		},
	};
}
